import clsx from 'clsx';
import Left from './Left';
import Right from './Right';
import Store from '../Store';
import * as React from 'react';
import { observer } from 'mobx-react';
import CompetencyStore from './Store';
import { activeTabPageClassName } from '../Types';

export interface Props {
  store: Store;
}

class Competencies extends React.Component<Props> {
  competencyStore: CompetencyStore = new CompetencyStore(
    this.props.store.resource.payload.competencies[0].payload.id,
  );

  render() {
    const { store } = this.props;
    return (
      <div
        id="competencies"
        className={clsx(activeTabPageClassName(store.state, 'competencies'), 'flex px-11 py-10')}
        data-intercom-target="competencies-tab-page"
      >
        <Left store={store} competencyStore={this.competencyStore} />
        <Right store={store} />
      </div>
    );
  }
}

export default observer(Competencies);
